import React from 'react';
import { BaseIcon } from '../../base/BaseIcon';
import { IconProps } from '../../types';

export const TsplatFallCosineIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M23 19C20.32 19 19.27 15.94 17.96 11.27C16.82 7.2 15.64 3 12 3C8.36 3 7.18 7.2 6.04 11.27C4.73 15.94 3.67 19 1 19C0.45 19 0 19.45 0 20C0 20.55 0.45 21 1 21C5.39 21 6.76 16.12 7.97 11.81C9.12 7.7 10.02 5 12 5C13.98 5 14.88 7.7 16.03 11.81C17.24 16.12 18.6 21 23 21C23.55 21 24 20.55 24 20C24 19.45 23.55 19 23 19Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

TsplatFallCosineIcon.displayName = 'TsplatFallCosineIcon';
